import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import EmptyCart from '@/assets/images/EmptyCart'
import { useAppSelector } from '@/redux/hooks'
import { Button as DesignButton } from '@itsrever/design-system'

interface CartEmptyStateProps {
    onClose?: () => void
}
export const CartEmptyState: React.FC<CartEmptyStateProps> = ({ onClose }) => {
    const { t } = useTranslation()

    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )

    const isMisako = settings.ecommerce_group === 'misako'
    const isHoff = settings.ecommerce_group === 'hoff'

    if (isHoff) {
        return (
            <div className="text-center">
                <p className="font-haas text-lg">
                    {t('full_catalog.no_items_added')}
                </p>
                <button
                    onClick={() => {
                        if (onClose) onClose()
                    }}
                    className="mt-10 cursor-pointer font-haas underline-offset-2 transition-all hover:underline"
                >
                    {t('full_catalog.shop_now')}
                </button>
            </div>
        )
    }

    if (isMisako) {
        return (
            <div className="flex flex-col items-center">
                <svg
                    width="82"
                    height="82"
                    viewBox="0 0 82 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M63.2133 82.0001C58.4983 82.0001 54.6765 78.1637 54.6765 73.4633C54.6765 68.7483 58.5129 64.9265 63.2133 64.9265C67.9137 64.9265 71.7501 68.7629 71.7501 73.4633C71.7501 78.1637 67.9137 82.0001 63.2133 82.0001ZM63.2133 68.3383C60.3872 68.3383 58.0883 70.6372 58.0883 73.4633C58.0883 76.2894 60.3872 78.5883 63.2133 78.5883C66.0394 78.5883 68.3383 76.2894 68.3383 73.4633C68.3383 70.6372 66.0394 68.3383 63.2133 68.3383Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M29.0368 82.0001C24.3218 82.0001 20.5 78.1637 20.5 73.4633C20.5 68.7483 24.3364 64.9265 29.0368 64.9265C33.7372 64.9265 37.5736 68.7629 37.5736 73.4633C37.5882 78.1637 33.7518 82.0001 29.0368 82.0001ZM29.0368 68.3383C26.2107 68.3383 23.9118 70.6372 23.9118 73.4633C23.9118 76.2894 26.2107 78.5883 29.0368 78.5883C31.8629 78.5883 34.1618 76.2894 34.1618 73.4633C34.1618 70.6372 31.8629 68.3383 29.0368 68.3383Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M70.0368 61.4999H30.6036C24.9221 61.4999 20.0021 57.4585 18.8746 51.8942L10.5575 10.2499H1.71321C0.761429 10.2499 0 9.48849 0 8.5367C0 7.59956 0.761429 6.82349 1.71321 6.82349H11.9632C12.7832 6.82349 13.4714 7.39456 13.6325 8.19991L22.2425 51.206C23.0332 55.1888 26.5621 58.0735 30.6182 58.0735H70.0514C70.9886 58.0735 71.7646 58.8349 71.7646 59.7867C71.75 60.7385 70.9886 61.4999 70.0368 61.4999Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M67.4304 47.8383H20.5001C19.5629 47.8383 18.7869 47.0768 18.7869 46.125C18.7869 45.1733 19.5483 44.4118 20.5001 44.4118H67.4304C70.0076 44.4118 72.204 42.479 72.5115 39.9165C72.6286 38.9793 73.5365 38.3204 74.4151 38.4376C75.3522 38.5547 76.0111 39.404 75.894 40.3411C75.3668 44.6168 71.7208 47.8383 67.4304 47.8383Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M39.2869 20.4999H15.3751C14.4379 20.4999 13.6619 19.7385 13.6619 18.7867C13.6619 17.8496 14.4233 17.0735 15.3751 17.0735H39.2869C40.224 17.0735 41.0001 17.8349 41.0001 18.7867C41.0001 19.7385 40.2386 20.4999 39.2869 20.4999Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M63.2133 37.5882C52.8608 37.5882 44.4265 29.1539 44.4265 18.8014C44.4265 8.44893 52.8462 0 63.2133 0C73.5658 0 82.0001 8.43429 82.0001 18.7868C82.0001 29.1393 73.5658 37.5882 63.2133 37.5882ZM63.2133 3.41179C54.7351 3.41179 47.8383 10.3086 47.8383 18.7868C47.8383 27.265 54.7351 34.1618 63.2133 34.1618C71.6915 34.1618 78.5883 27.265 78.5883 18.7868C78.5883 10.3086 71.6915 3.41179 63.2133 3.41179Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M70.0368 27.3382C69.5976 27.3382 69.1583 27.1771 68.8215 26.8404L55.1597 13.1786C54.4861 12.505 54.4861 11.4361 55.1597 10.7625C55.8333 10.0889 56.9022 10.0889 57.5758 10.7625L71.2376 24.4243C71.9111 25.0979 71.9111 26.1668 71.2376 26.8404C70.9154 27.1625 70.4761 27.3382 70.0368 27.3382Z"
                        fill="#000000"
                    ></path>
                    <path
                        d="M56.3751 27.3382C55.9358 27.3382 55.4965 27.1771 55.1597 26.8404C54.4861 26.1668 54.4861 25.0979 55.1597 24.4243L68.8215 10.7625C69.4951 10.0889 70.564 10.0889 71.2376 10.7625C71.9111 11.4361 71.9111 12.505 71.2376 13.1786L57.5758 26.8404C57.2536 27.1625 56.8144 27.3382 56.3751 27.3382Z"
                        fill="#000000"
                    ></path>
                </svg>
                <p className="mb-6 mt-11 font-[300] tracking-wider text-[15xs] [font-family:Inter]">
                    {t('full_catalog.no_items_added')}
                </p>
                <DesignButton
                    onClick={() => {
                        if (onClose) onClose()
                    }}
                >
                    <span className="text-[13px] font-[300] uppercase tracking-wide [font-family:Inter]">
                        {t('full_catalog.shop_now')}
                    </span>
                </DesignButton>
            </div>
        )
    }

    return (
        <div className="flex flex-col items-center">
            <div className="relative flex h-[190px] w-[400px] items-center justify-center gap-4 overflow-hidden">
                <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-r from-transparent to-white md:to-[#F2F2F2]" />
                <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-l from-transparent to-white md:to-[#F2F2F2]" />
                {[...Array(3)].map((_, index) => (
                    <div key={index}>
                        <EmptyCart
                            lightColor="var(--brand-600)"
                            darkColor="var(--brand-800)"
                        />
                    </div>
                ))}
            </div>
            <h3 className="mt-6 text-2xl font-semibold">
                {t('full_catalog.no_items_added')}
            </h3>
            <p className="mt-1 max-w-80 text-center text-base font-light text-slate-500">
                {t('full_catalog.empty_cart_description')}
            </p>
            <Button
                onClick={() => {
                    if (onClose) onClose()
                }}
                className="mt-4 cursor-pointer"
            >
                <span className="font-semibold drop-shadow-sm">
                    {t('full_catalog.shop_now')}
                </span>
            </Button>
        </div>
    )
}
const Button = styled.button`
    display: flex;
    padding: 9px 20px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    color: white;
    border-radius: 100px;
    border: 2px solid var(--brand-800);
    background: radial-gradient(
        160.21% 97.87% at 50% 100%,
        var(--brand-600) 0%,
        var(--brand-800) 100%
    );
    box-shadow: 0px 0px 16px 0px rgba(255, 255, 255, 0.5) inset;
    transition: box-shadow 0.3s ease-in-out;
    &:hover {
        box-shadow:
            0px 6px 12px rgba(0, 0, 0, 0.2),
            0px 0px 16px 0px rgba(255, 255, 255, 0.7) inset;
    }
`
